import type { ValidationResult, DeckSummary } from '../decks/formats.js';

export type DeckValidityPillProps = {
  validation: ValidationResult;
  summary: DeckSummary;
  deckSize: number;
};

export function DeckValidityPill({ validation, summary, deckSize }: DeckValidityPillProps) {
  if (validation.ok) {
    return (
      <span className="rounded-full border border-ec-defence bg-[rgba(85,167,47,0.18)] px-2.5 py-0.5 font-display text-xs font-semibold text-ec-go">
        ✓ Legal · {summary.totalCards}/{deckSize}
      </span>
    );
  }
  const headline =
    summary.totalCards !== deckSize
      ? `${summary.totalCards}/${deckSize} cards`
      : `${validation.errors.length} issue${validation.errors.length === 1 ? '' : 's'}`;
  return (
    <span
      className="rounded-full border border-ec-brass/60 bg-[rgba(245,168,28,0.18)] px-2.5 py-0.5 font-display text-xs font-semibold text-ec-brass"
      title={validation.errors.join('\n')}
    >
      ! {headline}
    </span>
  );
}
